import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section className="relative bg-gradient-to-br from-blue-600 to-indigo-800 text-white" aria-label={t('landing.heroSection.ariaLabel')}>
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1648611648035-805e9ae87437?w=1920&q=80"
          alt={t('landing.heroSection.imageAlt')}
          className="w-full h-full object-cover opacity-20"
          loading="eager"
        />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <div className="text-center">
          <div className="inline-block bg-white/10 dark:bg-surface-900/10 backdrop-blur-sm px-4 py-2 rounded-full mb-4">
            <span className="text-blue-100 text-sm font-semibold">{t('landing.hero.badge')}</span>
          </div>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight mb-6" data-testid="hero-title">
            {t('landing.hero.title')}
          </h1>
          <p className="text-xl sm:text-2xl mb-4 text-blue-100 font-semibold" data-testid="hero-subtitle">
            {t('landing.hero.subtitle')}
          </p>
          <p className="text-lg sm:text-xl mb-4 text-blue-200 max-w-3xl mx-auto" data-testid="hero-description">
            <span className="font-semibold text-white">{t('landing.hero.acronym')}</span> -
            {t('landing.hero.description')}
          </p>
          <div className="flex flex-wrap justify-center gap-3 mb-8 max-w-3xl mx-auto">
            <span className="bg-white/20 dark:bg-surface-900/20 backdrop-blur-sm px-4 py-2 rounded-lg text-sm">🤖 {t('landing.hero.features.aiCopilot')}</span>
            <span className="bg-white/20 dark:bg-surface-900/20 backdrop-blur-sm px-4 py-2 rounded-lg text-sm">🗣️ {t('landing.hero.features.voiceCommands')}</span>
            <span className="bg-white/20 dark:bg-surface-900/20 backdrop-blur-sm px-4 py-2 rounded-lg text-sm">⚡ {t('landing.hero.features.rpaAutomation')}</span>
            <span className="bg-white/20 dark:bg-surface-900/20 backdrop-blur-sm px-4 py-2 rounded-lg text-sm">🧠 {t('landing.hero.features.smartApproval')}</span>
            <span className="bg-white/20 dark:bg-surface-900/20 backdrop-blur-sm px-4 py-2 rounded-lg text-sm">📞 {t('landing.hero.features.aiPhone')}</span>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate('/signup')}
              className="bg-white dark:bg-surface-900 text-blue-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-50 transition duration-300 shadow-lg"
              data-testid="cta-button"
            >
              {t('landing.heroSection.ctaTrial')}
            </button>
            <button
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white dark:bg-surface-900 hover:text-blue-600 transition duration-300"
              data-testid="demo-button"
            >
              {t('landing.hero.ctaDemo')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
